import { mergeMap, merge } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Types, Creators } from '../ducks/retirement';
import { Api } from '../../api';

// eslint-disable-next-line
export const calculateRetirement = action$ => action$.pipe(
  ofType(Types.CALCULATE_RETIREMENT_REQUESTED),
  mergeMap((({ retirementData }) => Api.postRetirementData(retirementData)
    .then(res => Creators.calculateRetirementSuccess(res))
    .catch(err => Creators.calculateRetirementError(err))
  )),
);

export const retrieveRetirement = action$ => action$.pipe(
  ofType(Types.RETRIEVE_RETIREMENT_REQUESTED),
  mergeMap((({ uuid }) => Api.postRetrieveRetirement(uuid)
    .then(res => Creators.retrieveRetirementSuccess(res))
    .catch(err => Creators.retrieveRetirementError(err))
  )),
);

export const sendSMS = action$ => action$.pipe(
  ofType(Types.SEND_SMS_REQUESTED),
  mergeMap((uuid => Api.postSendSMS(uuid)
    .then(res => Creators.sendSMSSuccess(res))
    .catch(err => Creators.sendSMSError(err))
  )),
);

export const verifyCode = action$ => action$.pipe(
  ofType(Types.VERIFY_CODE_REQUESTED),
  mergeMap((data => Api.postVerifyCode(data)
    .then(res => Creators.verifyCodeSuccess(res))
    .catch(err => Creators.verifyCodeError(err))
  )),
);

const epicList = [
  calculateRetirement,
  sendSMS,
  verifyCode,
  retrieveRetirement,
];

export default epicList;
